<template>
    <div class="list-table">
         <el-row @click.native="selectCourse(index)" :class="{'active': selectedIndex == index, 'list-table-item': true}" v-for="(item, index) in displayCourses" :key="index">
            <el-col :span="12" class="course-name">
                <span>{{getCourseName(item)}}</span>
                <span v-if="courseType != 1">{{item.CourseCount}}/{{item.WeekCount}}</span>
            </el-col>
            <el-col :span="12">
                <div class="teacher-name"> 
                    <font size="1" v-text="item.TeacherName"></font>  <font size="1" v-text="item.StudentCount+'人'"></font>
                </div>
            </el-col>
        </el-row>
        <!-- <el-table :data="speedupCourses" :cell-class-name="'el-table-cell'" :header-row-class-name="'el-table-header'" :show-header="false">
            <el-table-column prop="CourseName" label="课程" width="50%">
            </el-table-column> 
            <el-table-column prop="StudentCount" label="人数" width="50%">
                 <template slot-scope="scope">
                    <div class="teacher-name"> 
                        <font size="1" v-text="scope.row.TeacherName"></font>  <font size="1" v-text="scope.row.StudentCount+'人'"></font>
                    </div>
                </template>
            </el-table-column>
        </el-table> -->
    </div>
</template>
<style lang="scss" scoped>
.list-table {
  border: 1px;
  border-style: solid;
  height: 666px;
  width: 100%;
  border-color: rgb(206, 211, 217);
  overflow-y: auto;

  .list-table-item {
    padding: 5px 5px;
    cursor: pointer;

    .course-name {
      font-size: 13px;
      word-wrap: break-word;
    }
    .teacher-name {
      text-align: right;
      font-size: 12px;
      color: #b7b7b7;
      word-wrap: break-word;
    }

    span {
      // -webkit-user-select:none;
      // user-select:none;
    }

    &.active {
      background-color: #e5e5e5;
    }
    &:hover {
      background-color: #e5e5e5;
    }
  }
}
</style>

<script>
import { getSpeedupCourseSummary } from "../../service/speedupCourse.service";
export default {
  data() {
    return {
      selectedIndex: 0,
      speedupCourses: [],
      displayCourses: [],
      universityGroupNumber: 0, 
      planDetail: [], 
      planId: 0, 
      termId: 0
    };
  },
  props:{courseType: Number,data: {}}, //["universityGroupNumber", "planDetail", "planId", "termId"],
  methods: {
    getCourseName(item) {
      if (!item.CourseClass) {
        return item.CourseName;
      } else {
        return item.CourseName + "-分班" + item.CourseClass;
      }
    },
    selectCourse(index) {
      if (this.selectedIndex == index) return;

      this.selectedIndex = index;
      if (index >= 0 && index < this.displayCourses.length) {
        let selectedItem = this.displayCourses[index];
        if (!!selectedItem) {
          this.$emit("selectCourse", selectedItem);
        }
      } else if (this.displayCourses.length == 0) {
        this.$emit("selectCourse", false);
      }
    },
    //获取所有课程
    loadSpeedupCourseSummary() {
      //if (!this.universityIdList || this.universityIdList.length == 0) {
      if (!this.planId) {
        this.speedupCourses = [];
        this.displayCourses = [];
        this.selectedIndex = -1;
        this.$emit("selectCourse", false);
        this.$emit("courseCountChanged", 0);
        return;
      }
      let group = this.universityGroupNumber;
      if (this.courseType != 1){
        group = 0;
      }
      getSpeedupCourseSummary(this.termId, this.planId, group).then(
        result => {
          if (!!result && result.success) {
            this.speedupCourses = result.data;

            this.getDisplayCourses();
            this.selectedIndex = -1;
            this.selectCourse(0);
            this.$emit("courseCountChanged", this.speedupCourses.length);
          }
        }
      );
    },
    getDisplayCourses() {
      if (!!this.planDetail) {
        let list = [];
        //let courseList = this.planDetail.SpeedupCourseList;
        this.speedupCourses.forEach(element => {
          let filterList = this.planDetail.filter(
            i =>
              i.CourseId == element.CourseId &&
              i.TeacherId == element.TeacherId &&
              i.CourseClass == element.CourseClass
          );
          if (this.courseType == 1){
            if (filterList.length == 0) {
              list.push(element);
            }
          }else{
            if (element.CourseCount == 0 || element.WeekCount > filterList.length){
              list.push(element);
            }
          }
         
        });
        this.displayCourses = list;
      } else {
        this.displayCourses = this.speedupCourses;
      }
    }
  },
  watch: {
    data: function(){
      if (!!this.data){
        this.universityGroupNumber = this.data.universityGroupNumber;
        this.planId = this.data.planId;
        this.termId = this.data.termId;
        this.planDetail = this.data.planDetail;
      }else{
        this.universityGroupNumber = 0;
        this.planId =0;
        this.termId = 0;
        this.planDetail = [];
      }
      this.loadSpeedupCourseSummary();
    }
    // universityGroupNumber: function() {
    //   this.loadSpeedupCourseSummary();
    // },
    // planId:function(){
    //   this.loadSpeedupCourseSummary();
    // },

    // //分配给plan的课程
    // planDetail: function() {
    //   console.log("planDetail");
    //   this.getDisplayCourses();
    //   this.selectedIndex = -1;
    //   this.selectCourse(0);
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/speedupCourse/speedupCourseSummaryList.vue